export interface StateInterface {
  loginBackground: boolean | string;
  branded: boolean;
  applicationName: string;
}

const state: StateInterface = {
  loginBackground: false,
  branded: false,
  applicationName: "",
};

export default state;
